import React from 'react';
import { info } from "@randajan/simple-app/info";


import { Block } from "@randajan/jet-react/dom/block";

import "./LoginScreen.scss";
import { extendURL } from "@randajan/oauth2-client";
import { page } from '@randajan/jet-react/base/page';

import { Button } from '@randajan/jet-react/dom/form';
import tab from '@randajan/jet-react/base/tab';
import { Img } from '@randajan/jet-react/dom/img';

import { icons } from '../icons';
import { GrantButton } from './GrantButton/GrantButton';


const redirect = async (kind) => {
    const { pathname } = page.get();
    const { srcTag } = tab.get();
    window.location = extendURL(`${info.home}/oauth/${kind}`, {
        srcPath: pathname,
        srcTag
    });
}


export const LoginScreen = (props) => {
    const { } = props;

    return (
        <Block level={0} className="LoginScreen popScreen" caption="Přihlaš se">
            <div className="buttons">
                <GrantButton id="google"/>
                <GrantButton id="seznam"/>
                <GrantButton id="facebook" lock/>
                <GrantButton id="instagram" lock/>
            </div>
            <span className="claim">Další metody přihlášení brzy</span>
        </Block>
    )
}

